import { render, staticRenderFns } from "./InjuryTypeAdd.vue?vue&type=template&id=3b2e21b1&"
import script from "./InjuryTypeAdd.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports